/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
import {TagInstance} from "./tag-instance";

/*
 * UI Class used to represent/show the available emAssets for the User
 */
export class TagUI {
  tag: TagInstance;
  selected = false;
}

